<template>
    <div class="DashboardOnboardingIntroView">
        <div class="topSection">
            <div
                class="Slide__image"
                :data-name="`slide${activeSlideIndex + 1}`"
                :style="{ backgroundImage: `url(${getSlideImage(activeSlideIndex + 1)})` }"
            />
        </div>
        <!-- <WidthWrapper> -->
        <SimpleSlides
            :button-label="$t(`getStarted`)"
            on-dark-background
            @update:index="activeSlideIndex = $event"
            @done="gotoNext()"
        >
            <template slot="slides">
                <div v-for="i of 5" :key="i" class="Slide">
                    <!-- <div class="spacer1" /> -->

                    <div class="Slide__title">
                        {{ $t(`slide${i}.title`) }}
                    </div>

                    <div class="Slide__text">
                        {{ $t(`slide${i}.text`) }}
                    </div>
                </div>
            </template>
        </SimpleSlides>
        <!-- </WidthWrapper> -->
    </div>
</template>

<translations>
  getStarted: 'Get Started'
  getStarted_no: 'Kom i gang'

  slide1:
    title: 'Stay Ahead of Change'
    title_no: 'Ligg et hode foran'
    text: 'The world is changing fast. Memolife uses new insight about the brain to let you stay ahead of change with the most important skills for today and tomorrow.'
    text_no: 'Samfunnet endrer seg hurtig. Memolife bruker ny innsikt om hjernen til å hjelpe deg ligget et hode foran disse endringene med de viktigste ferdighetene for i dag og i morgen.'
    image: './slide1.png'
  slide2:
    title: 'Level Up Your Brain'
    title_no: 'Spill hjernen topptrent'
    text: 'Learn fast with fun hacks, remember forever with smart intervals and ace new habits with real life scenarios.'
    text_no: 'Lær hurtig med morsomme hacks, husk for alltid med smarte intervaller og skap nye vaner med ekte scenarioer.'
    image: './slide2.png'
  slide3:
    title: 'Do Your First Brain Date'
    title_no: 'Gå på første hjernedate'
    text: 'Level up your brain with superfast learning of theory, practice and videos - a 3 minute brain date is all you need.'
    text_no: 'Spill hjernen i form med lynrask læring av teori, praksis og video – en hjernedate på 3 minutter er alt du trenger.'
    image: './slide3.svg'
  slide4:
    title: 'Get Your First Life Key'
    title_no: 'Få din første livsnøkkel'
    text: 'Enjoy your progress with life keys - the mastery badges that appear after finishing brain dates of theory and pratice.'
    text_no: 'Nyt fremgangen med livsnøkler - pokalene for mestring, som dukker opp etter noen hjernedates med teori og praksis.'
    image: './slide4.svg'
  slide5:
    title: 'Wear Your First Belt'
    title_no: 'Motta ditt første belte'
    text: 'The white belt makes you ready to embark on your first learning journeys towards the black belt in life - at work and at home.'
    text_no: 'Det hvite beltet gjør deg klar til å sette ut på de første læringreisene mot det svarte beltet i livet – på jobb og hjemmebane.'
    image: './slide5.svg'
</translations>

<script>
import SimpleSlides from '@/components/SimpleSlides';
// import WidthWrapper from '../../components/WidthWrapper'

const images = require.context('./', true, /\.(png|jpg|svg)$/);

export default {
    components: { SimpleSlides },
    data() {
        return {
            activeSlideIndex: 0
        };
    },
    methods: {
        imageUrl(path) {
            return images(`${path}`);
        },
        getSlideImage(slideNumber) {
            return this.imageUrl(this.$t(`slide${slideNumber}.image`));
        },
        gotoNext() {
            this.$store.dispatch('moduleApp/markDashboardOnboardingAsShown');
            this.$router.push({
                name: 'DashboardHomeView'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardOnboardingIntroView {
    background: $dashboard-background;
    display: flex;
    flex-direction: column;
    padding-bottom: 1em;
}
.SimpleSlides {
    // width: calc(100% - 2em);
    width: 80%;

    // max-width: 30em;
    align-self: center;
    flex: 1;
    // background: transparent;
    padding: 0;

    display: flex;
    flex-direction: column;

    /deep/ .slides {
        flex: 1;
    }
}

.topSection {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.Slide__image {
    height: 100%;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    // outline: 1px solid rgba(0, 128, 0, 0.24);
    // outline: 1px solid rgba(yellow, 0.1);

    &[data-name='slide1'] {
        background-size: auto 100%; // 140%;
        background-position: center top;
    }
    &[data-name='slide2'] {
        width: 24em;
        height: 16em;
        margin-bottom: 2em;
        background-size: contain;
    }
    &[data-name='slide3'] {
        width: 18em;
        height: 14em;
        margin-bottom: 2em;
        background-size: 80%;
        // background-position: 80% center;
    }
    &[data-name='slide4'] {
        width: 20em;
        height: 16em;
        margin-bottom: 2em;
    }
    &[data-name='slide5'] {
        width: 22em;
        height: 22em;
        margin-bottom: 1em;
        //align-self: flex-start;
        // background-size: 100%;
        // background-position: bottom right;
    }
}

.Slide {
    flex: 1;
    padding-left: 1.5em;
    padding-right: 1.5em;
}
.Slide__title {
    color: white;
    font-size: 180%;
    font-weight: 600;
    text-align: center;
    // max-width: 10em;
}
.Slide__text {
    // color: #939393;
    color: rgba(white, 0.5);
    font-size: 110%;
    line-height: 1.5em;
    text-align: center;
    max-width: 20em;
    margin-top: 1em;
}

@include media('>=mobile') {
    .Slide {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .Slide__title {
        max-width: none;
    }
}
@include media('<mobile') {
    .topSection {
        flex: 1.5;
    }
    .Slide__title {
        text-align: left;
    }
    .Slide__text {
        text-align: left;
    }

    .SimpleSlides {
        width: calc(100% - 2em);
    }

    .Slide__image {
        // align-self: center;
        // margin-bottom: 0;

        &[data-name='slide1'] {
            // background-size: auto 120%;
            // background-position: 70% bottom 10%;
        }
        // &[data-name="slide2"] {
        //   align-self: center;
        //   margin-bottom: 0;
        // }
        // &[data-name="slide3"] {
        //   align-self: center;
        //   margin-bottom: 0;
        // }
        // &[data-name="slide4"] {
        //   align-self: center;
        //   margin-bottom: 0;
        // }
        // &[data-name="slide5"] {
        //   align-self: center;
        //   margin-bottom: 0;
        // }
    }
}
</style>
